import type { ReactNode } from "react";
import { LuEye } from "react-icons/lu";
import { useStartViewTransitionState } from "use-start-view-transition";

import { Button } from "@/components/ui/button";

export const ContentBlurOverlay = ({
  children,
  buttonText,
  onReveal,
}: {
  children: ReactNode;
  buttonText: string;
  onReveal?: () => void;
}) => {
  const [showContent, setShowContent] = useStartViewTransitionState(false);

  if (showContent) {
    return null;
  }

  return (
    <div
      className="
        absolute inset-0 z-1 flex flex-col flex-wrap items-center justify-center
        gap-4 rounded-md border
        bg-[color-mix(in_srgb,var(--background),transparent_20%)] py-4 text-sm
        backdrop-blur-3xl
      "
    >
      {children}
      <Button
        onClick={() => {
          setShowContent(true);
          onReveal?.();
        }}
        size="xs"
        variant="destructive"
      >
        <LuEye className="mr-2" />
        {buttonText}
      </Button>
    </div>
  );
};
